import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workWeek: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.work-week',
		defaultMessage: 'Work week',
		description: 'header text for work week section',
	},
	openTip: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.open-tip',
		defaultMessage: 'Select the days of the week this calendar will use.',
		description: 'open tip for selecting days for the week',
	},
});
